import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {DeleteNovaAgentInput, DeleteNovaAgentMutation} from './__generated__/DeleteNovaAgentMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// No `@connection`-backed way to remove the edge in place: the agent's own category connection is
// keyed `NovaStudioCatalogue_agents` on the parent category record, and a RANGE_DELETE would need
// that parent id, which the caller no longer meaningfully has once the agent is gone. Like
// `DeleteNovaAgentCategoryMutation`, the caller refetches the catalogue in `onSuccess` instead.
const mutation = graphql`
	mutation DeleteNovaAgentMutation($input: DeleteNovaAgentInput!) {
		deleteNovaAgent(input: $input) {
			deletedNovaAgentId
			deletedVersionCount
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DeleteNovaAgentInput>,
	onSuccess?: RelayOnCompleted<DeleteNovaAgentMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<DeleteNovaAgentMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
